import React, {Component, PropTypes} from 'react';
import {
  Button,
  Checkbox,
  Col,
  ControlLabel, Form,
  Modal,
} from '@sketchpixy/rubix';
import styled from 'styled-components';
import {ClipLoader} from 'react-spinners';
import {css} from 'react-emotion';

import {cancelContract, updateContractProduct} from '../../../api/api';
import DeviceType from "../../../constants/DeviceType";
import SideType from "../../../constants/SideType";
import CurrencyType from "../../../constants/CurrencyType";
import ContractStatus from "../../../constants/ContractStatus";
import {StyledFormGroup} from "../../payment/FromStyle";
import InputValidationType from "../../../constants/InputValidationType";

const override = css`
  margin: auto 8px auto auto;
`;

const ButtonText = styled.div`
  display: flex;
`;

class EditProductModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      medicalDevice: [],
      loading: false,
    };
  }

  componentDidMount() {
      const contract = this.props.contract;

    if (contract.contractDevicesDetail) {
      const contractDevicesDetail = JSON.parse(contract.contractDevicesDetail);
      const medicalDevice = contractDevicesDetail.medicalDevice;

      this.setState({
        medicalDevice
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const contract = nextProps.contract;
    if (contract.contractDevicesDetail) {
      const contractDevicesDetail = JSON.parse(contract.contractDevicesDetail);
      const medicalDevice = contractDevicesDetail.medicalDevice;

      this.setState({
        medicalDevice
      });
    }
  }

  deviceChangeHandler = (event, deviceType) => {
    const checked = event.target.checked;

    let medicalDevice  = this.state.medicalDevice;
    console.log(medicalDevice)

    let hasDeviceType = this.hasDevice(deviceType);
    if (checked) {
      if(!hasDeviceType)
      {
        if(deviceType.isSidedDevice)
        {
          medicalDevice.push({side: [], deviceType: deviceType.name});
        }else{
          medicalDevice.push({deviceType: deviceType.name});
        }
      }
    } else {
      if(hasDeviceType)
      {
        medicalDevice = medicalDevice.filter(function(device, index, arr){
          return device.deviceType !== deviceType.name;
        });
      }
    }
    console.log(medicalDevice)
    this.setState({
      medicalDevice
    });
  };

  sideTypeChangeHandler = (event, deviceType, sideType) => {
    const checked = event.target.checked;

    let medicalDevice  = this.state.medicalDevice;
    console.log(medicalDevice)

    let hasSideType = this.hasDeviceSide(deviceType, sideType);

    let foundDeviceType = this.getDeviceType(deviceType);

    if (checked) {
      if(!hasSideType)
      {
        foundDeviceType.side.push(sideType.name);
      }
    } else {
      if(hasSideType)
      {
        foundDeviceType.side = foundDeviceType.side.filter(function(side, index, arr){
          return side !== sideType.name;
        });
      }
    }
    console.log(medicalDevice)
    this.setState({
      medicalDevice
    });
  };

  getSideDevice = (deviceType) => {
    return (
        <StyledFormGroup style={{marginLeft: '10px'}}>
          <Col componentClass={ControlLabel} xs={1}>
            Side
          </Col>
          <Col xs={11}>
            {
              SideType.enumValues.map(
                  sideType => (
                      <Checkbox
                          inline
                          key={sideType}
                          id={sideType.name}
                          name={`${deviceType.name}_side_selector`}
                          onClick={event => this.sideTypeChangeHandler(event, deviceType, sideType)}
                          checked={this.hasDeviceSide(deviceType, sideType)}
                      >
                        {sideType.title}
                      </Checkbox>
                  ))
            }
          </Col>
        </StyledFormGroup>
    );
  };

  getDeviceSide= (deviceType, sideType) => {
    let device = this.getDeviceType(deviceType);
    let deviceSide = null;

    device && device.side.forEach(side => {
      if (sideType.name === side) {
        deviceSide = side;
      }
    });

    return deviceSide;
  };

  hasDeviceSide = (deviceType, sideType) => {
    return this.getDeviceSide(deviceType, sideType) !== null;
  };

  getDeviceType = (deviceType) => {
    let contract = this.props.contract;

    let foundDevice= null;
    this.state.medicalDevice.forEach(device => {
      if (deviceType.name === device.deviceType) {
        foundDevice  = device;
      }
    });

    return foundDevice;
  };

  hasDevice = (deviceType) => {
    return this.getDeviceType(deviceType) !== null;
  };

  saveProduct = () =>
  {
    var typeArray = Object.values(DeviceType);
    for(let deviceIndex = 0; deviceIndex < this.state.medicalDevice.length; deviceIndex++) {
      let device =    this.state.medicalDevice[deviceIndex];
      for(let typeIndex = 0; typeIndex < typeArray.length; typeIndex++) {
        let t = typeArray[typeIndex ];
        if (t.name === device.deviceType && t.isSidedDevice && device.side.length === 0) {
          alert("Please choose side for " + t.title);
          return;
        }
      }
    };

    this.setState({
      loading: true,
    });

    updateContractProduct(this.props.contract.contractId, this.state.medicalDevice, (err, result) => {
      this.setState({
        loading: false,
      });

      if (err) {
        Messenger().post({
          type: 'error',
          message: `${err.message} (${err.statusCode})`
        });
      } else {
        if (result.statusCode === "0" || result.statusCode === 0) {
          this.props.closeModal({}, this.state.medicalDevice);
        } else {
          this.props.closeModal({});
          Messenger().post({
            type: 'error',
            message: `Failed to Update Contract product`
          });
        }
      }
    });
  };

  render() {
    return (
        <Modal
            show={this.props.showModal}
            onHide={this.props.closeModal}
            backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Product</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{height: '300px'}}>
            <Form horizontal>
            <StyledFormGroup>
              <Col xs={3} componentClass={ControlLabel}>
                Select Products
              </Col>
              <Col xs={9}>
                {
                  DeviceType.enumValues.map(deviceType => {
                    return (
                        <div key={deviceType}>
                          <Checkbox
                              name="device"
                              onChange={event => this.deviceChangeHandler(event, deviceType)}
                              checked={this.hasDevice(deviceType)}
                          >
                            {deviceType.title}
                          </Checkbox>
                          {
                            this.hasDevice(deviceType)  && deviceType.isSidedDevice  ? this.getSideDevice(deviceType) : null
                          }
                        </div>
                    );
                  })
                }
              </Col>
            </StyledFormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.props.closeModal}>Cancel</Button>
            <Button bsStyle="brownishgray" onClick={this.saveProduct} disabled={this.state.loading}>
              <ButtonText>
                <ClipLoader
                    className={override}
                    sizeUnit={'px'}
                    size={12}
                    color={'#123abc'}
                    loading={this.state.loading}
                />
                <span>
                  Confirm
                </span>
              </ButtonText>
            </Button>
          </Modal.Footer>
        </Modal>
    );
  }
}

EditProductModal.propTypes = {
  contract: PropTypes.object.isRequired,
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default EditProductModal;



// WEBPACK FOOTER //
// ./src/routes/patient/Modal/EditProductModal.js